import React from "react"
import { Box, Flex, Text } from "theme-ui"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { CalendarDays, CalendarCheck, Clock } from "lucide-react"
import { typography, colors } from "@greythr/shared-components"
import { assignToUrl } from "@greythr/shared-utils/navigate-cross-app"

const AuthorHeaderSection = ({
  authors = [],
  publishDate,
  updatedDate,
  timeToRead,
  variant = "light",
}) => {
  const textColor = variant === "dark" ? colors.white : colors.black

  return (
    <Box>
      {authors.length > 0 && (
        <Flex sx={containerStyles}>
          <Text sx={{ ...typography.h6, color: textColor }}>By</Text>
          {authors.map((author, index) => (
            <Flex
              key={`author-${index}`}
              sx={{
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              {author.profileImage && (
                <Box sx={imageStyles}>
                  <GatsbyImage
                    image={getImage(author.profileImage)}
                    alt={author.profileImageAltText || author.firstName}
                    style={{ width: "100%", height: "100%" }}
                    imgStyle={{ objectFit: "cover" }}
                  />
                </Box>
              )}
              <Text
                sx={{
                  ...typography.textMd400,
                  color: textColor,
                  cursor: author.slug ? "pointer" : "default",
                  "&:hover": author.slug ? { textDecoration: "underline" } : {},
                }}
                onClick={() =>
                  author.slug &&
                  assignToUrl(`/resources/author/${author.slug}`)
                }
              >
                {author.firstName} {author.lastName}
              </Text>
            </Flex>
          ))}
        </Flex>
      )}
      <Flex
        sx={{
          gap: ["0.75rem", "0.75rem", "1.5rem", "1.5rem"],
          flexWrap: "wrap",
        }}
      >
        {publishDate && (
          <Flex sx={{ alignItems: "center", gap: "0.5rem" }}>
            <CalendarDays size={16} color={textColor} />
            <Text sx={{ ...typography.h6, color: textColor }}>Published:</Text>
            <Text sx={{ ...typography.textMd400, color: textColor }}>
              {publishDate}
            </Text>
          </Flex>
        )}
        {updatedDate && updatedDate !== publishDate && (
          <Flex sx={{ alignItems: "center", gap: "0.5rem" }}>
            <CalendarCheck size={16} color={textColor} />
            <Text sx={{ ...typography.h6, color: textColor }}>Updated:</Text>
            <Text sx={{ ...typography.textMd400, color: textColor }}>
              {updatedDate}
            </Text>
          </Flex>
        )}
        {timeToRead && (
          <Flex sx={{ alignItems: "center", gap: "0.5rem" }}>
            <Clock size={16} color={textColor} />
            <Text sx={{ ...typography.h6, color: textColor }}>
              Reading Time:
            </Text>
            <Text sx={{ ...typography.textMd400, color: textColor }}>
              {timeToRead} min read
            </Text>
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

const { containerStyles, imageStyles } = {
  containerStyles: {
    alignItems: "center",
    flexWrap: "wrap",
    gap: "0.75rem",
    mb: "1rem",
  },
  imageStyles: {
    width: "1.5rem",
    height: "1.5rem",
    overflow: "hidden",
    flexShrink: 0,
  },
}

export default AuthorHeaderSection;
